// ═══════════════════════════════════════════════════════════════
//  JOB OPENINGS — these show in the Careers section of the website
//
//  TO EDIT a job:    change the text between the "quotes"
//  TO ADD a job:     copy a whole { ... } block, paste it below the
//                    last one, then change the text
//  TO REMOVE a job:  delete its whole { ... } block
//
//  type can be: "Full-time"  "Part-time"  "Casual"  "Contract"
//               "Apprenticeship"
// ═══════════════════════════════════════════════════════════════

export const jobs = [
  {
    id: "job-1",
    title: "Senior Heritage Painter",
    type: "Full-time",
    location: "North Adelaide, SA",
    summary: "Lead heritage restorations across Adelaide's listed villas and cottages.",
  },
  {
    id: "job-2",
    title: "Commercial Project Lead",
    type: "Full-time",
    location: "Adelaide CBD, SA",
    summary: "Run off-hours commercial repaints for offices, retail and hospitality.",
  },
  {
    id: "job-3",
    title: "Apprentice Painter & Decorator",
    type: "Apprenticeship",
    location: "Mile End Workshop, SA",
    summary: "Learn the craft end-to-end with senior painters on real Adelaide projects.",
  },
  {
    id: "job-4",
    title: "Spray Coating Technician",
    type: "Contract",
    location: "Lonsdale, SA",
    summary: "Factory-grade sprayed finishes for cabinetry and joinery.",
  },
];
